import React, {useEffect, useState, useRef} from "react";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAlertContext } from "../context/Alerts.js";
import SimpleBar from 'simplebar-react';
import axios from 'axios';
import { useBaseUrlContext } from "../context/Base_url.js";
import { useForm, Controller  } from "react-hook-form";
import { QueryClient, useQuery, useQueryClient } from "@tanstack/react-query";
import { useErrHandleContext } from "../context/Err_handle.js";

import {ThemeProvider, Container, Typography, Tabs, Tab, Tooltip, FormControl, InputLabel, OutlinedInput} from '@mui/material';
import {ThemeMain, ThemeCustom} from '../styles/Theme.js';
import 'simplebar-react/dist/simplebar.min.css';
import 'filepond/dist/filepond.min.css';

import ButtonImgMain from "../components/button/Button_img_main.js";
import FooterBar from "../components/navbar/Footer_bar.js";

import NotFound from '../assets/no-results-found.svg'
import TrashDark from '../assets/trash-dark.svg';
import ClipboardIcon from '../assets/Clipboard.svg';
import LoaderIcon from '../assets/loader.gif'
import AiIcon from '../assets/ai-generate.svg'
import LoadingIcon from '../assets/tube-spinner.svg'

const EmailAutomation = () => {

    const subjectRef = useRef(null);
    const bodyRef = useRef(null);
    const buttonRefs = useRef([]);
    const [cursorPosition, setCursorPosition] = useState(null);
    //const [cvList, setCvList] = useState([])
    const [tabValue, setTabValue] = useState(0);
    const [files, setFiles] = useState([]);
    const [selectCheckbox, setSelectCheckbox] = useState([])
    const [selectAll, setSelectAll] = useState(false)
    const [loader, setLoader] = useState(true)
    const { baseUrl } = useBaseUrlContext();
    const { sucessAlert, failAlert } = useAlertContext();
    const navigate = useNavigate();
    const [hasError, setHasError] = useState(false);
    const [emailSubject, setEmailSubject] = useState('');
    const [emailBodyVal, setEmailBodyVal] = useState('');
    const [emailSubjectVal, setEmailSubjectVal] = useState('');
    const [validationSubject, setValidationSubject] = useState(false);
    const [validationBody, setValidationBody] = useState(false);
    const [aiGenerating, setAiGenerating] = useState(false)
    const queryClient = useQueryClient()
    const {handleError} = useErrHandleContext()

    //get email data

    const fetchEmailData = async ({queryKey}) => {

        const [_key, tabValue ] = queryKey
        console.log('queryKey > ', queryKey)

            try{

                const header = {
                    'Authorization': localStorage.getItem('token')
                }
               
                const response = await axios.get(`${baseUrl}/settings/mailContent/${tabValue === 0 ?'Shortlisted':'Rejected' }`, {headers:header})
                
                const res = response.data
                console.log('res', response);
    
                if(res.code === 200){
                    console.log('fetchEmailData', res.data)
                    //setLoader(false)
                    return res.data;
                }
                else{
                    console.log(res, '204 error')
                    if(res.code !== 204){
                        failAlert(true, res.message)
                        
                    }

                    setLoader(false)
                    
                    throw new Error()
                    
                }

            } catch(error) {
                console.log('error', error)
                handleError(error)
                setLoader(false)
                
                return [];
            }

        
    }


    //useQuery hook for get email data

    const {isLoading, data:emailData} = useQuery({

        queryKey: ['fetchEmailData', tabValue],
        queryFn: fetchEmailData,
        cacheTime: 30 * 60 * 1000,
    })

    //query handle manually for get email data

    const fetchEmailDataHandler = async () => {
        queryClient.invalidateQueries(['fetchEmailData', tabValue])
    }

    //set email data

    useEffect(() => {
        console.log('emailData >> ccc', emailData)
        if (emailData) {
            console.log('emailData >> ', emailData)
            setEmailBodyVal(emailData.mailContent);
            setEmailSubjectVal(emailData.mailSubject)
        }
        else{
            setEmailBodyVal('');
            setEmailSubjectVal('')
        }
    }, [emailData]);

    //submit reject single

    const rejectSingle = (id) => {

        console.log('reject')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'idList': [id]
        })

        axios
        .put(`${baseUrl}/email/updateStatus/REJECTED`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('reject res', res.data)
                sucessAlert(true, res.message)
                setSelectAll(false)
                setSelectCheckbox([])
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }

    //tab change

    const handleChange = (e, val) => {
        console.log('handleChange', val);
        setTabValue(val)
    }



    //Assign to job

    const assignToJob = (jobId, docId) => {

        console.log('assignToJob', jobId, docId)

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            'docId': docId,
            'jobId': jobId
        })

        axios
        .post(`${baseUrl}/email/assignJobForDoc`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('shortlist res', res.data)
                sucessAlert(true, res.message)
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })

    }


    //Cancel func

    const cancel = () => {
        console.log('cancel')
        navigate('/job-board')
    }

    //Save func

    const submitBtn = () => {
        console.log('submit')
    }

    //generate email w AI

    const generateWithAI = () => {
        console.log('generateWithAI')
        setAiGenerating(true)

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            "jobId": "",
            "jobTitle": ""
        })

        axios
        .post(`${baseUrl}/settings/generateMailBody/${tabValue === 0 ? 'Shortlisted' : 'Rejected'}`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('generateMailBody res', res, 'sfs', res.data, res.data.mailSubject, res.mailContent)
                sucessAlert(true, res.message)
                setEmailBodyVal(res.data.mailContent.replace(/\n/g, "<br>"));
                setEmailSubjectVal(res.data.mailSubject.replace(/\n/g, "<br>"))
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
            setAiGenerating(false)

        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
            setAiGenerating(false)

        })


    }

    //remove later

    useEffect(()=>{
        console.log('emailBodyVal, emailSubjectVal', emailBodyVal, emailSubjectVal)
    },[emailBodyVal, emailSubjectVal])

    // Function to handle content changes in the contenteditable div and sync with React Hook Form

    const handleInputSubject = () => {
        
        //console.log("emailSubject:", editedContent); 
        setValidationSubject(false)
    };

    const handleInputBody = () => {
        
        //console.log("emailBody", editedContent); 
        setValidationBody(false)
    };

    //save data in state

    const saveData = () => {
        const editedContentSub = subjectRef.current.innerHTML; 
        setEmailSubjectVal(editedContentSub); 
        const editedContentBody = bodyRef.current.innerHTML; 
        setEmailBodyVal(editedContentBody); 
        console.log('saveData', editedContentSub, editedContentBody)
        return { subject: editedContentSub, body: editedContentBody };

    }

    // Submit the form
    
    const Submit = (e) => {
        e.preventDefault()
        let {subject, body} = saveData()
        console.log('saveData xxx', subject, body)


        if(!emailBodyVal || !emailSubjectVal){

            if(!emailBodyVal){
                setValidationBody(true)
            }

            if(!emailSubjectVal){
                setValidationSubject(true)
            }
            console.log("Saving Template: xxx", ); 
        }
        else{
            console.log("Saving Template:", ); 
            postEmailData(subject, body)
        }
    };

    //email submit api 

    const postEmailData = (subject, body) => {

        console.log('post email')

        const header = {
            'Authorization': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }

        const data = JSON.stringify({
            "mailType": tabValue === 0 ?'Shortlisted':'Rejected',
            "mailSubject": subject,
            "mailContent": body
        })

        axios
        .post(`${baseUrl}/settings/mailContent`, data, {headers:header})
        .then((response) => {
            console.log('res', response);
            const res = response.data;
            if(res.code === 200){
                console.log('email post res', res)
                sucessAlert(true, res.message)
            }
            else{
                console.error(res.message)
                failAlert(true, res.message)
            }
        })
        .catch((err) => {
            console.error('Internal Server Error', err)
            failAlert(true,'Oops! Something went wrong. Please hang tight and try again in a moment.')
        })


    }

    // Function to store cursor position

    const handleCursorPosition = () => {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        setCursorPosition(range);
        }
    };

    // Function to insert specific text and move the cursor next to the inserted text

    const insertTextAtCursor = (text) => {

        if (cursorPosition) {
        const textNode = document.createTextNode(text);

        // Insert the new text node at the stored cursor position
        cursorPosition.insertNode(textNode);

        // Create a new range and set the cursor after the inserted text
        const newRange = document.createRange();
        newRange.setStartAfter(textNode);
        newRange.setEndAfter(textNode);

        // Set the new range as the current selection
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(newRange);

        setCursorPosition(null); // Reset cursor position
        }

    };

    // Effect to detect outside clicks and clear cursor position

    useEffect(() => {

        const handleClickOutside = (event) => {
        if (
            subjectRef.current &&
            !subjectRef.current.contains(event.target) &&
            bodyRef.current &&
            !bodyRef.current.contains(event.target) &&
            !buttonRefs.current.some((button) => button && button.contains(event.target)) // Check if click is outside all buttons
        ) {
            setCursorPosition(null); // Clear cursor position if click is outside the div and buttons
        }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };

    }, []);


    return(
        <ThemeProvider theme={ThemeCustom}>
            <Container maxWidth="xl" className="mt-20 mb-5 pt-5">
                <div>
                    <div className="mb-7 flex justify-between items-center">
                        <Typography variant="textheader2" component={'div'}>Email Automation</Typography>
                        <ButtonImgMain 
                            variant='primary' 
                            type='button' 
                            disabled={false} 
                            name='Job Board'
                            class='capitalize'
                            img={ClipboardIcon}
                            posision={'right'}
                            onClick={()=>navigate(`/job-board`)}
                        />
                    </div>
                    <div className="flex justify-between items-center">
                        <div className="flex items-center">
                            <Typography variant="text18Light" component={'div'} className="max-w-[25rem] truncate mr-3">{ tabValue ? 'Rejected Candidate Notification Template' : 'Shortlist Candidate Notification Template'}</Typography>
                        </div>
                        <Tabs onChange={handleChange} value={tabValue}>
                            <Tab label="Shortlisted" value={0} />
                            <Tab label="Rejected" value={1} />
                        </Tabs>
                    </div>
                    <form onSubmit={e => Submit(e)}>
                    <div className='rounded-xl rounded-tr-none mb-5 bg-white p-5 border border-solid border-cultured'>
                        <div className="flex justify-between items-start"> 
                            <div className="w-4/5">
                                <SimpleBar className={`review-selected rounded-xl p-0 m-0`}>
                                    {files ? (
                                        <div className="pr-5">
                                            <FormControl fullWidth variant="standard">
                                                <div className="flex justify-between">
                                                    <InputLabel shrink htmlFor="jobTitle">Email Subject</InputLabel>
                                                    {!emailSubjectVal && validationSubject ? ( <span className="text-red font-medium text-sm">Email subject is required</span>) :``}
                                                </div>
                                                <div 
                                                    dangerouslySetInnerHTML={{__html:emailSubjectVal}}
                                                    ref={subjectRef}
                                                    contentEditable
                                                    onClick={handleCursorPosition}
                                                    onKeyUp={handleCursorPosition}
                                                    onInput={handleInputSubject} // Sync changes with React Hook Form
                                                    className="bg-culturedLight border-solid border border-culturedLight py-3 px-4 rounded-xl text-base overflow-y-auto focus:!border-culturedDark max-h-[3.125rem] outline-none"
                                                />
                                            </FormControl>
                                            <FormControl fullWidth variant="standard" >
                                                <div className="flex justify-between">
                                                    <InputLabel shrink htmlFor="jobTitle">Email Body</InputLabel>
                                                    {!emailBodyVal && validationBody ? (<span className="text-red font-medium text-sm">Email body is required</span>) : ``}
                                                </div>
                                                <div
                                                    dangerouslySetInnerHTML={{__html:emailBodyVal}}
                                                    ref={bodyRef}
                                                    contentEditable
                                                    onClick={handleCursorPosition}
                                                    onKeyUp={handleCursorPosition}
                                                    onInput={handleInputBody} // Sync changes with React Hook Form
                                                    className="bg-culturedLight py-3 px-4 rounded-xl text-base border-solid border border- overflow-y-auto border-culturedLight focus:!border-culturedDark max-h-[21rem] outline-none min-h-[22rem]"
                                                />
                                            </FormControl>
                                        </div>
                                    ):(
                                        loader ? (
                                            <div className="w-full flex-col flex justify-center items-center review-unselected">
                                                <img src={LoaderIcon} alt="loading" className="w-[4rem] mb-5"/>
                                                <Typography variant="textheader3" component={'div'}>Loading...</Typography>
                                            </div>
                                        ):(
                                        <div className="w-full flex-col flex justify-center items-center review-unselected">
                                            <img src={NotFound} alt="not found" className="w-[25%] mb-5"/>
                                            <Typography variant="textheader3" component={'div'}>Email Templates Not Found!</Typography>
                                        </div>
                                        )
                                    )}
                                </SimpleBar>
                            </div>
                            <div className="w-1/5 flex flex-col justify-start items-end border-l border-solid border-cultured review-selected border-0 pl-5">
                                    <div className="mb-8">
                                        <ButtonImgMain 
                                            variant='purple' 
                                            type='button' 
                                            disabled={false} 
                                            name={aiGenerating ? 'Generating' : 'Generate with AI'}
                                            class='capitalize ai-btn min-w-[13rem]'
                                            img={aiGenerating ? LoadingIcon :AiIcon}
                                            posision={''}
                                            onClick={generateWithAI}
                                        />
                                        
                                    </div>
                                    <div >
                                    <Typography component={'div'} variant="textheader3" className="mb-5">Insert Tags</Typography>
                                    <div className="flex flex-col justify-start items-end">
                                        <div 
                                            className="mb-4 bg-white cursor-pointer text-sm hover:bg-secondary hover:bg-opacity-20 border-secondary border border-solid p-2 px-4 text-secondary rounded-3xl font-medium" 
                                            onClick={() => insertTextAtCursor('{{CANDIDATE_NAME}}')}
                                            ref={(el) => (buttonRefs.current[0] = el)}
                                        >
                                                Candidate Name
                                        </div>
                                        <div 
                                            className="mb-4 bg-white cursor-pointer text-sm hover:bg-secondary hover:bg-opacity-20 border-secondary border border-solid p-2 px-4 text-secondary rounded-3xl font-medium" 
                                            onClick={() => insertTextAtCursor('{{ORGANIZATION_NAME}}')}
                                            ref={(el) => (buttonRefs.current[1] = el)}
                                        >
                                            Organization Name
                                        </div>
                                        <div 
                                            className="mb-4 bg-white cursor-pointer text-sm hover:bg-secondary hover:bg-opacity-20 border-secondary border border-solid p-2 px-4 text-secondary rounded-3xl font-medium" 
                                            onClick={() => insertTextAtCursor('{{JOB_TITLE}}')}
                                            ref={(el) => (buttonRefs.current[2] = el)}
                                        >
                                            Job Title
                                        </div>

                                    </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <FooterBar
                        submitBtn={submitBtn}
                        cancel={cancel}
                        btnOutline={'Cancel'}
                        disabledSecondary={false}
                    />
                    </form>
                </div>
            </Container>
        </ThemeProvider>
        
    )
}

export default EmailAutomation;